/**
 * Created by yihong on 1/15/18.
 */
export const ACTION_GET_USER_INFO = 'ACTION_GET_USER_INFO'　//获取ticket后发出信息，用于调用接口获取用户信息

export const PAGE_CREATE = 'PAGE_CREATE'; // HOMEPAGE CREATED时发出　用来调用接口，不要用于dom操作

export const USRE_INFO_LOAD = 'USRE_INFO_LOAD'; //用户信息加载完成

export const SHOW_CHANNEL_CHOOSER = 'SHOW_CHANNEL_CHOOSER'
export const CLOSE_CHANNEL_CHOOSER = 'CLOSE_CHANNEL_CHOOSER'


//获取抽奖记录　中奖记录弹窗展示时刷新　或者在中奖记录的弹窗中提交信息时刷新
export const GET_LOTTERY_HISTORY = 'GET_LOTTERY_HISTORY';
export const ADD_LOTTERY_CHANCE = 'ADD_LOTTERY_CHANCE'


export const GET_ZP_INFO = 'GET_ZP_INFO'; //获取赠片信息

export const GET_ZP_RANK = 'GET_ZP_RANK' //获取赠片排行




// WEBPACK FOOTER //
// ./src/constant/eventbus.js